module.exports = __webpack_public_path__ + "static/media/image_groupsale_medium_gray.8aa03ba7.png";